import { ServiceProviderRoutes } from "./pages/service-provider/routes";
import { SmartApplyRoutes } from "./pages/smart-apply/route";
import { SurveysRoute } from "./pages/surveys/route";
import { SettingsRoutes } from "./pages/settings/route";
import { ProcManagementRoute } from "./pages/proc-management/route";
import { LoginRoutes } from "./pages/login/route";
import { GrafferUtilityToolsRoute } from "./pages/graffer-utility-tools/route";
import { RedirectRoutes } from "./helpers/redirect-routes";
import { AuthedRoute } from "./helpers/authed-route";
import { TtzkPortalRoute } from "./pages/ttzk-portal/route";
import { SurveysServiceProviderRoutes } from "./pages/surveys/service-provider/route";
import { HelpRoutes } from "./pages/help/route";
import { DataTransferRoute } from "./pages/data-transfer/routes";

export const RootRoute = () => {
  return (
    <div>
      <AuthedRoute exact path="/" component={RedirectRoutes} />
      <LoginRoutes />
      <SmartApplyRoutes />
      <SettingsRoutes />
      <SurveysRoute />
      <ProcManagementRoute />
      <TtzkPortalRoute />
      <GrafferUtilityToolsRoute />
      <DataTransferRoute />
      <ServiceProviderRoutes />
      <SurveysServiceProviderRoutes />
      <HelpRoutes />
    </div>
  );
};
